<template>
    <div class="row no-gutters bg-dark">
        <div class="col-md-12">
            <ul class="nav nav-pills nav-fill bg-dark p-0">
                <li class="nav-item" v-for="(livestream, index) in livestreams">
                    <a class="nav-link text-white pointer"
                       :class="{active: videoOptions.sources[0].src === livestream.url}"
                       @click="setActiveStream(livestream.url)">
                        Stream #{{ index }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="col-md-12 h-inherit">
            <div class="align-center h-inherit" v-if="streamOnline">
                <video-player :options="videoOptions" v-if="videoOptions.sources[0].src !== null && domReady"></video-player>
            </div>
            <div class="align-center h-inherit" v-else>
                <div class="row no-gutters mt-2">
                    <div class="col-10 offset-1">
                        <div class="alert alert-info">
                            {{ $t("UI_LIVE_CARD_STREAM_OFFLINE") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VideoPlayer from '../../../../includes/VideoPlayer';

export default {
  name: 'LivestreamPanel',
  components: { VideoPlayer },
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        aspectRatio: '16:9',
        fluid: true,
        sources: [
          {
            src: null,
            type: 'application/x-mpegURL',
          },
        ],
      },
      domReady: false,
      streamOnline: false,
      streamOnlineCheckInterval: null,
    };
  },
  mounted() {
    this.domReady = true;

    if (this.mainStream !== null) {
      this.setActiveStream(this.mainStream.url);

      // Periodically check if the live stream is online
	        const vue = this;
      this.$nextTick(() => {
	            vue.streamOnlineCheckInterval = setInterval(() => {
		            vue.checkLiveStreamAvailability();
	            }, 10000);
      });
    }
  },
  methods: {
    reloadPlayer() {
	      this.domReady = false;
	      this.$nextTick(() => {
		      this.domReady = true;
		      this.checkLiveStreamAvailability();
	      });
    },
    setActiveStream(livestream) {
      this.videoOptions.sources[0].src = livestream;

      this.reloadPlayer();
      this.checkLiveStreamAvailability();
    },
    checkLiveStreamAvailability() {
      	if (this.videoOptions.sources[0].src !== null) {
      		const streamUrl = this.videoOptions.sources[0].src;

      		axios.get(streamUrl).then((response) => {
          this.streamOnline = true;
        }).catch((error) => {
            	if (error.response !== undefined) {
            if (error.response.status === 404) {
              this.streamOnline = false;
            }
          }
        });
      }
    },
  },
	  beforeDestroy() {
    	// Dispose the timer before the component is destroyed.
    clearInterval(this.streamOnlineCheckInterval);
    this.streamOnlineCheckInterval = null;
	  },
  computed: {
    mainStream() {
      return this.livestreams !== null ? this.liveData.livestreams.find(stream => stream.isMain) : null;
    },
    liveData() {
      return this.$store.getters.activeInstanceData.live;
    },
    livestreams() {
      return this.liveData !== null && this.liveData !== undefined ? this.liveData.livestreams : null;
    },
  },
};
</script>

<style scoped>
    .nav-pills .nav-link.active {
        background-color: #57616b;
    }
</style>
